// extracted by mini-css-extract-plugin
export default {"down":"down-Qp8gt","icon":"icon-YXIS5"};